import React, { useEffect, useState } from 'react';
import Icon from 'components/styleguide/icon/Icon';
import LoadingSpinner from 'components/styleguide/loading_spinner/LoadingSpinner';
import Modal from 'components/styleguide/modal/Modal';

const styles = require('./AiLoadingModal.module.scss');

interface AiLoadingModalProps {
  imageUrl: string;
  triggerId?: string;
  isOpen?: boolean;
  steps?: string[];
  context?: 'talent' | 'company';
}

const DEFAULT_STEPS = ['General information', 'Technical skills', 'Experience & Education'];
const MIN_STEP_DELAY_MS = 2000;
const MAX_EXTRA_DELAY_MS = 2000;

export default function AiLoadingModal({
  imageUrl,
  triggerId,
  isOpen,
  steps = DEFAULT_STEPS,
  context = 'company',
}: AiLoadingModalProps) {
  const [started, setStarted] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  useEffect(() => {
    if (!started || activeStep >= steps.length - 1) return undefined;

    const delay = MIN_STEP_DELAY_MS + Math.random() * MAX_EXTRA_DELAY_MS;
    const timer = setTimeout(() => setActiveStep((prev) => prev + 1), delay);
    return () => clearTimeout(timer);
  }, [started, activeStep, steps.length]);

  return (
    <Modal
      triggerId={triggerId}
      isOpen={isOpen}
      onOpen={() => setStarted(true)}
      dismissible={false}
      ariaLabel="Preparing your profile"
    >
      <img src={imageUrl} alt="" className={styles.illustration} />
      <h2 className={styles.title}>Preparing your profile...</h2>
      <ul className={styles.steps}>
        {steps.map((step, index) => (
          <li key={step} className={styles.step}>
            <span className={styles.stepIcon}>
              {index < activeStep && <Icon name="circleCheck" color={`${context}-border-base`} size="md" />}
              {index === activeStep && <LoadingSpinner size="small-medium" context={context} />}
              {index > activeStep && <span className={styles.pendingCircle} aria-hidden="true" />}
            </span>
            <span className={styles.stepLabel}>{step}</span>
          </li>
        ))}
      </ul>
    </Modal>
  );
}
